import React from "react";
import { Navigate } from "react-router-dom";

import useAuthStore from "@/store/use-auth-store";
import {
  SupportHeaderSection,
  MyTicketsSection,
  SupportInfoAside,
} from "@/features/support";

/**
 * My Tickets sayfası (/support/tickets) — login gerektirir.
 * Misafir kullanıcı destek ana sayfasına yönlendirilir.
 *
 * Tüm ekran boyutlarında viewport yüksekliğine sabitlenir; yalnızca ticket
 * listesi kayar, başlık ve sayfalama sabit kalır. Mobilde ekstra kaydırma
 * mesafesi yaratmaması için yardım bilgisi barındıran yan panel gizlenir.
 */
const SupportTicketsPage: React.FC = () => {
  const { user } = useAuthStore();

  if (!user?._id) {
    return <Navigate to="/support" replace />;
  }

  return (
    <div className="mx-auto flex h-full w-full max-w-6xl flex-col gap-4 px-3 py-4 sm:gap-8 sm:px-4 sm:py-8 lg:py-10">
      <div className="shrink-0">
        <SupportHeaderSection />
      </div>

      <div className="grid min-h-0 flex-1 grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="flex min-h-0 flex-1 flex-col lg:col-span-2">
          <MyTicketsSection />
        </div>
        <div className="hidden lg:block">
          <SupportInfoAside />
        </div>
      </div>
    </div>
  );
};

export default SupportTicketsPage;
